import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SurveyAnswerService } from '../../public-api';
import { Options, Question, Survey } from '../shared/model-service';
import { PopupService } from '../shared/popup-service';

@Component({
  selector: 'app-yes-or-no',
  templateUrl: './yes-or-no.component.html',
  styleUrls: ['./yes-or-no.component.css']
})
export class YesOrNoComponent implements OnInit {
  panelOpenState = true;
  @Input() Question: Question;
  @Input() SurveyBase: Survey
  show: boolean = false;
  questiondsIdLinks: number[] = [];
  questions: Question[] = [];
  result: Question;
  selectedOptions = [];
  popupService: PopupService;
  response: string = "";
  timer: any;
  constructor(private dialog: MatDialog, private surveyService: SurveyAnswerService) { }

  ngOnInit(): void {
    this.popupService = new PopupService(this.dialog);
    if (this.Question.result != "" && this.Question.result != null) {
      this.treatEditSurvey();
    } else {
      this.Question.result = "";
    }

  }

  sortBy(prop: string) {
    return this.Question.options.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
  }

  onNgModelChange(selectedOptions) {

    if (this.timer != null) {
      clearTimeout(this.timer)
    }

    this.timer = setTimeout(() => {
      this.panelOpenState = false;
    }, 5000);


    this.Question.options.forEach(option => {
      option.result = null
    });

    this.show = true
    this.questiondsIdLinks = [];
    this.questions = [];
    this.response = selectedOptions[0].title

    let option: Options = selectedOptions[0]
    this.Question.result = selectedOptions[0].title
    let links = option?.links;
    if (links != []) {
      links.forEach(link => {
        this.questiondsIdLinks.push(link.questionDestinationId);

        /**Open popup */
        if (link.popupDestinationId != null) {
          this.popupService.openPopupDialog(link.popupDestinationId, this.SurveyBase);
        }

        /**Open tips */
        if (link.tipDestinationTipId != null) {
          this.popupService.openTipDialog(link.tipDestinationTipId);
        }
      });

      this.questiondsIdLinks.forEach(link => {
        this.result = this.SurveyBase.questions.find(x => x.id == link);
        if (this.result != null) {
          this.questions.push(this.result);
        }

      })
    }
  }


  treatEditSurvey() {
    this.panelOpenState = false;
    this.show = true;
    this.response = this.Question.result;

    var option = this.Question.options.find(x => x.title == this.response)
    option.links.forEach(element => {
      this.questiondsIdLinks.push(element.questionDestinationId);
    });

    this.questiondsIdLinks.forEach(element => {
      this.result = this.SurveyBase.questions.find(x => x.id == element);
      if (this.result != null) {
        this.questions.push(this.result);
      }
    })
  }
}
